import { getAPIUrl } from '../helpers/App';

export const APIgetUploadPages = params => (
  window.axios.get(getAPIUrl('/upload-pages'), { params })
    .then(response => (response))
);

export const APIgetUploadPage = uploadPageId => (
  window.axios.get(getAPIUrl(`/upload-pages/${uploadPageId}`))
    .then(response => (response))
);

export const APIgetUploadPageUploads = (uploadPageId, params) => (
  window.axios.get(getAPIUrl(`/upload-pages/${uploadPageId}/uploads`), { params })
    .then(response => (response))
);

export const APIcreateUploadPage = uploadPage => (
  window.axios.post(getAPIUrl('/upload-pages'), uploadPage)
    .then(response => (response))
);

export const APIupdateUploadPage = (uploadPageId, uploadPage) => (
  window.axios.patch(getAPIUrl(`/upload-pages/${uploadPageId}`), uploadPage)
    .then(response => (response))
);

export const APIdeleteUploadPage = uploadPageId => (
  window.axios.delete(getAPIUrl(`/upload-pages/${uploadPageId}`))
    .then(response => (response))
);

export const APIauthUploadPage = (uploadPageId, params) => (
  window.axios.post(getAPIUrl(`/upload-pages/${uploadPageId}/auth`), params)
    .then(response => (response))
);

export const APIgetUploadPagesUsers = params => (
  window.axios.get(getAPIUrl('/upload-pages/users'), { params })
    .then(response => (response))
);

export const APIloadUploadPageTerms = uploadPageUuid => (
  window.axios.get(getAPIUrl(`/upload-pages/${uploadPageUuid}/load_terms`))
    .then(response => (response.data))
);

export const APIacceptUploadPageTerms = uploadPageUuid => (
  window.axios.patch(getAPIUrl(`/upload-pages/${uploadPageUuid}/accept_terms`))
    .then(response => (response.data))
);

export const APIfetchAcceptedTermsOfService = (uploadPageUuid, params) => (
  window.axios.get(getAPIUrl(`/upload-pages/${uploadPageUuid}/accepted_terms`), { params })
    .then(response => (response))
);
